export function LogoAddress(theme: "dark" | "light", icon = false) {
  if (!icon)
    if (theme === "light") {
      return "/logoLight.webp";
    } else if (theme === "dark") {
      return "/logoDark.webp";
    } else return "";
  else {
    if (theme === "light") {
      return "/logo/new-logo-e-h.png";
    } else if (theme === "dark") {
      return "/logo/new-logo-e-h-w.png";
    } else return "";
  }
}
